import { Group, MantineColor, StyleProp, Text } from "@mantine/core"

import { CountryFlag } from "../../atoms/CountryFlag/CountryFlag.tsx"
import { CountryIso3166 } from "../Inputs/CountrySelector/CountriesSelector.types.ts"
import { CountryMapper } from "../Inputs/CountrySelector/CountrySelector.tsx"

interface Props {
  countryIso3166: CountryIso3166
  countriesMapper: CountryMapper
  width?: number
  color?: StyleProp<MantineColor>
}

export const CountryLabel = ({
  countryIso3166,
  countriesMapper,
  width,
  color,
  ...rest
}: Props) => {
  if (!countriesMapper[countryIso3166]) {
    return null
  }
  return (
    <Group gap={3} {...rest}>
      <CountryFlag countryIso3166={countryIso3166} width={width} />
      <Text c={color} fw="bold">
        {countriesMapper[countryIso3166].countryName}
      </Text>
    </Group>
  )
}
